import { appConfig } from '../../Config/AppConfig';

const About = () => {
    return <h1>About: {appConfig.APP_NAME}</h1>;
};

export default About;
